import { DEFAULT_SORTING_KEYS } from './search-sorting';
import { MY_UPLOADS_SORTING_KEYS } from './uploads-sorting';

export const WISHLIST_GQL_SORTING_MAP = {
    [DEFAULT_SORTING_KEYS.PRICE_ASC]: '{ sort: price, order: ASC }',
    [DEFAULT_SORTING_KEYS.PRICE_DESC]: '{ sort: price, order: DESC }',
    [DEFAULT_SORTING_KEYS.CREATED_AT_DESC]: '{ sort: addedAt, order: DESC }',
    [MY_UPLOADS_SORTING_KEYS.TITLE_ASC]: '{ sort: title__keyword, order: ASC }',
    [DEFAULT_SORTING_KEYS.BEST_SELLERS_DESC]: '{ sort: bestsellerRating, order: DESC }'
};

export const SCHOOL_WISHLIST_GQL_SORTING_MAP = {
    ...WISHLIST_GQL_SORTING_MAP,
    [DEFAULT_SORTING_KEYS.VOTES_DESC]: '{ sort: schoolWishlistVotesCount, order: DESC }'
};
